
import { ReactNode } from 'react';
import { MessageParamsInput, TextDisplayParams } from './MessageParams';
import createTime from '../utils/createTime'
import findLinkOrEmail from '../utils/findLinkOrEmail'
import { regLink } from '../messageHelpers';

const regReplace = /@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))/gi;

export interface RenderableMessage {
  renderText(TextNode: keyof JSX.IntrinsicElements | React.ComponentType<{dangerouslySetInnerHTML: { __html: string }}>): ReactNode;
}

export interface CalculatedMessageParameters {
  originalText: string
}

export abstract class BaseMessage implements RenderableMessage {
  id: string;
  text: string;
  date: string;
  clientTimestamp: string;
  isFake: boolean;
  nickname: string;
  type: string;
  subtype: string;
  authorId: string;
  lastEditedTime: string;
  visitorServerUrl: string;
  serverUrl: string;
  parentClientTimestamp: string;
  isFirstInGroup: boolean;
  isLastInGroup: boolean;
  modCount: string;
  translatedTextHtml: string;
  textDisplayTemplate: (params: TextDisplayParams) => string;

  /* Свойства которые не приходят извне */
  originalText: string;
  time: string;

  constructor({
    id = `${Date.now()}`,
    nickname = '',
    text = '',
    date = `${Date.now()}`,
    type = '',
    subtype = '',
    authorId = '',
    modCount = '0',
    lastEditedTime = '0',
    translatedTextHtml = '',
    clientTimestamp = `${Date.now()}`,
    isFake = false,
    visitorServerUrl = '',
    serverUrl = '',
    parentClientTimestamp = `${Date.now()}`,
    isFirstInGroup = true,
    isLastInGroup = true,
    textDisplayTemplate = ({ originalTextHtml }) => originalTextHtml,
  }: MessageParamsInput) {
    this.id = id
    this.nickname = nickname
    this.text = textDisplayTemplate({ originalTextHtml: text, translatedTextHtml })
    this.date = date
    this.type = type
    this.subtype = subtype
    this.authorId = authorId
    this.modCount = modCount
    this.lastEditedTime = lastEditedTime
    this.translatedTextHtml = translatedTextHtml
    this.clientTimestamp = String(clientTimestamp)
    this.isFake = isFake
    this.visitorServerUrl = visitorServerUrl
    this.serverUrl = serverUrl
    this.parentClientTimestamp = String(parentClientTimestamp)
    this.isFirstInGroup = isFirstInGroup
    this.isLastInGroup = isLastInGroup
    this.textDisplayTemplate = textDisplayTemplate

    this.originalText = text
    this.time = createTime(date)
    this.parse()
  }

  abstract renderText(
    TextNode: keyof JSX.IntrinsicElements | React.ComponentType<{dangerouslySetInnerHTML: { __html: string }}>
  ): ReactNode;

  parse(): void {
    if (!this.text) {
      this.text = '';
      return;
    }
    if (this.text.match('<img') && this.text.match('Smiley:')) {
      this.text = this.text.replace(/\{visitor-server-url\}/g, this.visitorServerUrl);
      this.subtype = 'smiley';
    }

    if (this.text.match(regLink) || this.text.replace(/mailto:/gi, ' ').match(regReplace)) {
      const link = findLinkOrEmail(this.text, regLink);
      this.text = link.text;
      this.subtype = link.subtype ? link.subtype : this.subtype;
    }
  }
}
